import React, { useEffect } from 'react'
import ErrorContainer from '@chegg-wt/core/components/ErrorContainer'
import ProjectAlert from '@chegg-wt/core/components/Folders/ProjectAlert'
import Header from '@chegg-wt/core/components/Folders/Header'
import styled from 'styled-components'
import { Separator } from '@chegg-wt/core/components/Folders/styled'
import MainContent from '@chegg-wt/core/components/Folders/MainContent'
import { CREATE_PROJECT_MODAL } from '@chegg-wt/core/state/modals/constants'
import { useRouter } from 'next/router'
import { connect } from 'react-redux'
import { OpenModalPayload } from '@chegg-wt/core/state/modals/types'
import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import { useProtectedRoute } from '@chegg-wt/core/hooks/useProtectedRoute'
import { Messages } from '@chegg-wt/core/types/core'
import { ProductName } from '@chegg-wt/core/types/site'
import { openModal } from '@chegg-wt/core/state/modals/actions'
import { LvpMarginWrapper } from './LargeVideoPlayerLayout'

const Background = styled.div`
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor20};
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 900px;
  margin: auto;
`

const InnerContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.xl};
`

interface FoldersProps {
  copy: Messages
  siteName?: ProductName
  openModal: (payload: OpenModalPayload) => void
}

export { FoldersTop as FoldersLayoutTop } from '@chegg-wt/core/components/Folders/Header'

export const FoldersLayout: React.FC<FoldersProps> = ({ copy, siteName, openModal }) => {
  useProtectedRoute()
  const router = useRouter()

  useEffect(() => {
    const { create } = router.query
    if (create === 'project') {
      openModal({ name: CREATE_PROJECT_MODAL, data: {} })
    }
  }, [router.query])

  return (
    <>
      <SEOTitle title={`My Citation Lists | ${siteName}`} enable={!!siteName} />
      <Background>
        <LvpMarginWrapper>
          <Container>
            <InnerContainer>
              <ErrorContainer />
              <ProjectAlert />
              <Header />
              <Separator separationSize="small" />
              <MainContent copy={copy} />
            </InnerContainer>
          </Container>
        </LvpMarginWrapper>
      </Background>
    </>
  )
}

const mapDispatchToProps = {
  openModal,
}

export default connect(null, mapDispatchToProps)(FoldersLayout)
